<div class="border-card border-0 px-2 px-md-4 py-1 scroll-container" ref="manage_workflow">
  <NavigationBackButton />
  <div class="px-3">
    <!-- Top Info Card (Styled Like Example) -->
    <div class="card-header bg-white card-nav-tabs border-0 shadow mt-2 rounded-top-lg ms-2 mb-2">
      <div class="d-flex justify-content-between align-items-center">
        <!-- Left Side: Founder Info -->
        <div class="d-flex align-items-center">
          <i class="bx bx-user fs-4 text-dark me-2"></i>
          <div class="d-flex flex-column justify-content-center">
            <!-- Clickable Entity Name -->
            <p
              class="fw-bold text-dark mb-0 text-x d-flex align-items-center pointer"
              @click="open_edit_entity_modal"
              data-bs-toggle="modal"
              data-bs-target="#edit_entity_modal"
            >
              {{ entity_name }}
              <i class="bx bx-edit ms-2 text-primary fs-5"></i>
            </p>

            <span
              class="text-xs fw-bold"
              :style="{ color: get_status_color(application_status) }"
              :class="{ 'text-muted': !is_status_colors_loaded }"
            >
              {{ application_status }}
              <small v-if="!is_status_colors_loaded" class="text-xxs">(loading colors...)</small>
            </span>
          </div>
        </div>
        <!-- Right Side: Logs Button -->
      </div>
    </div>


    <!-- Main Application Layout -->
    <div class="overview-application-container">
      <!-- Scrollable Floating Tabs -->
      <div class="overview-vertical-tabs-container overview-scrollable-container">
        <div v-for="tab in visible_tabs" :key="tab.id" class="overview-floating-tab shadow rounded-lg"
          :class="{ 'active': active_tab === tab.id }" @click="select_tab(tab.id)"
          :data-tooltip="tab.label ">
          <div class="overview-floating-tab-inner">
            <span class="text-xs">{{ tab.label  }}</span>
          </div>
        </div>
      </div>

      <!-- Dropdown Section Content Area -->
      <div class="ms-2 overview-dropdown-column rounded-lg shadow-lg">
        <div class="overview-accordion-container mb-3 border-0 rounded-lg" id="stages_accordion">

          <!-- DYNAMIC DB MAIN SECTION (shows when you click any injected "ms-<id>" tab) -->
          <div v-if="content_type === 'dynamic'" class="accordion-item bg-secondary-dark">
            <h2 class="accordion-header primary-green text-white border-0">
              <div class="d-flex align-items-center w-100 p-1 border-0 rounded text-xxs bg-secondary-dark">
                <div class="position-relative flex-grow-1 me-2">
                  <span class="text-xs text-bright">{{ tab_label(active_tab) }}</span>
                </div>
              </div>
            </h2>
            <div class="collapse" :class="{ show: selectedDropdown === active_tab }">
              <div class="mb-3 rounded-lg p-2 border-0 mt-1">
                <RenderSections :form_main_section_id="dropdown_forms_id(active_tab)" :application_id="application_id"
                  :entity_profile_id="entity_profile_id"
                  :application_form_id="application_form_id" />
              </div>
            </div>
          </div>

          <!-- STATIC TABS (use IDs, not labels) -->

          <!-- Overview -->
          <div v-if="active_tab === 'Overview'" class="accordion-item bg-secondary-dark">
            <h2 class="accordion-header primary-green border-0">
              <div class="d-flex align-items-center w-100 p-1 border-0 rounded text-xxs bg-secondary-dark">
                <div class="position-relative flex-grow-1 me-2">
                  <span class="text-xs text-bright">Application Overview</span>
                </div>
              </div>
            </h2>
            <div class="collapse" :class="{ show: selectedDropdown === 'Overview' }">
              <ApplicationOverviewDetails />
            </div>
          </div>

          <!-- Verification Information -->
          <div v-if="active_tab === 'Verification'" class="accordion-item bg-secondary-dark">
            <h2 class="accordion-header primary-green border-0">
              <div class="d-flex align-items-center w-100 p-1 border-0 rounded text-xxs bg-secondary-dark">
                <div class="position-relative flex-grow-1 me-2">
                  <span class="text-xs text-bright">Verification Results</span>
                </div>
              </div>
            </h2>
            <div class="collapse" :class="{ show: selectedDropdown === 'Verification' }">
               <EntityVerificationResults :entity_profile_id="$route.query.entity_profile_id" />
            </div>
          </div>

          <!-- Requested Information -->
          <div v-if="active_tab === 'Requests'" class="accordion-item bg-secondary-dark">
            <h2 class="accordion-header primary-green border-0">
              <div class="d-flex align-items-center w-100 p-1 border-0 rounded text-xxs bg-secondary-dark">
                <div class="position-relative flex-grow-1 me-2">
                  <span class="text-xs text-bright">Requested Information</span>
                </div>
              </div>
            </h2>
            <div class="collapse" :class="{ show: selectedDropdown === 'Requests' }">
              <RequestedInformationUpdate />
            </div>
          </div>

          <!-- Documents -->
          <div v-if="active_tab === 'Documents'" class="accordion-item bg-secondary-dark">
            <h2 class="accordion-header primary-green border-0">
              <div class="d-flex align-items-center w-100 p-1 border-0 rounded-lg text-xxs bg-secondary-dark">
                <div class="position-relative flex-grow-1 me-2">
                  <span class="text-xs text-bright">Documents</span>
                </div>
              </div>
            </h2>
            <div class="collapse" :class="{ show: selectedDropdown === 'Documents' }">
              <EntityDocuments />
            </div>
          </div>

          <!-- Compliance -->
          <div v-if="active_tab === 'compliance'" class="accordion-item bg-secondary-dark">
            <h2 class="accordion-header primary-green border-0">
              <div class="d-flex align-items-center w-100 p-1 border-0 rounded text-xxs shadow bg-secondary-dark">
                <div class="position-relative flex-grow-1 me-2">
                  <span class="text-xs text-bright">Compliance Overview</span>
                </div>
              </div>
            </h2>
            <div class="collapse" :class="{ show: selectedDropdown === 'compliance' }">
              <ViewComplianceChecks />
            </div>
          </div>

          <!-- Contracts -->
          <div v-if="active_tab === 'E-Signing'" class="accordion-item bg-secondary-dark">
            <h2 class="accordion-header primary-green border-0">
              <div class="d-flex align-items-center w-100 p-1 border-0 rounded text-xxs bg-secondary-dark">
                <div class="position-relative flex-grow-1 me-2">
                  <span class="text-xs text-bright">Contracts</span>
                </div>
              </div>
            </h2>
            <div class="collapse" :class="{ show: selectedDropdown === 'E-Signing' }">
              <ESigning />
            </div>
          </div>

          <!-- Invoices -->
          <div v-if="active_tab === 'Invoices'" class="accordion-item bg-secondary-dark">
            <h2 class="accordion-header primary-green border-0">
              <div class="d-flex align-items-center w-100 p-1 border-0 rounded text-xxs bg-secondary-dark">
                <div class="position-relative flex-grow-1 me-2">
                  <span class="text-xs text-bright">Payment Details</span>
                </div>
              </div>
            </h2>
            <div class="collapse" :class="{ show: selectedDropdown === 'Invoices' }">
              <EntityInvoiceOverview />
            </div>
          </div>
          <div v-if="content_type === 'none'" class="accordion-item bg-secondary-dark">
            <h2 class="accordion-header primary-green border-0">
              <div class="d-flex align-items-center w-100 p-1 border-0 rounded text-xxs bg-secondary-dark">
                <div class="position-relative flex-grow-1 me-2">
                  <span class="text-xs text-bright">{{ active_tab }}</span>
                </div>
              </div>
            </h2>
            <p class="p-3 text-center text-muted">No content available for this tab.</p>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>

<!-- Edit Entity Modal -->
 <teleport to="body">
<div class="modal fade" id="edit_entity_modal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
      <div class="modal-header border-bottom-0 cute-header shadow-lg">
        <p class="modal-title text-white text-xxs">Edit Entity Name</p>
        <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal"
                @click="show_edit_entity_modal = false"></button>
      </div>
        <div class="modal-body">
          <div class="form-group mb-3">
            <label class="form-label text-xxs">Entity Name:</label>
            <input
              type="text"
              v-model.trim="current_edit_entity.name"
              :class="{'is-invalid': entity_name_error}"
              @input="entity_name_error = false"
              class="form-control text-xxs rounded-3 p-2 shadow-sm"
              placeholder="Enter entity name"
              @keyup.enter="save_edited_entity"
            />
            <div v-if="entity_name_error" class="invalid-feedback small">
              Please enter an entity name
            </div>
          </div>
        </div>

        <div class="modal-footer border-0 p-2 d-flex justify-content-end">
          <button
            type="button"
            class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
            @click="save_edited_entity"
            :disabled="!current_edit_entity.name?.trim()"
            data-bs-dismiss="modal"
          >
            Save
          </button>
        </div>

    </div>
  </div>
</div>
</teleport>
